import { apiUrl } from '../../../settings'


export const updateIssueWebPageUrl = () => {
  return `${apiUrl}/api/updateSpecialIssueWebPage`
}
export const getIssueWebPageUrl = () => {
  return `${apiUrl}/api/singleSpecialIssueWebPage`
}

export const updateSpecialIssueWebPageDrawerUrl = () => {
  return `${apiUrl}/updateSpecialIssueWebPageDrawer`
}

export const deleteSpecialIssueItemUrl = () => {
  return `${apiUrl}/deleteSpecialIssueItem`
}
